import React, { useEffect } from 'react'
import { Button, ResultPage, Toast } from 'antd-mobile-v5'
import { WhiteSpace } from 'antd-mobile'
import { FormattedMessage } from 'react-intl'
import { useHistory, useLocation } from 'react-router-dom'
import ResultPageContent from './ResultPageContent'
import { getParameterByName } from '../../components/common/utils'

const ApplicationSubmitResult = () => {
  const {
    state: { code, paid, paymentType, autoRenew },
    pathname,
    search,
  } = useLocation()
  const { push } = useHistory()
  const type = getParameterByName('type')

  useEffect(() => {
    if (autoRenew) {
      const params = { code, type, paid, paymentType, redirect: pathname }
      if (search) {
        params.redirect = pathname + search
      }
      Toast.show({
        content: '即将跳转到自动更新签署流程...',
        afterClose: () => push('/auto_renew', params),
      })
    }
  }, [autoRenew])

  return (
    <ResultPage status="success" title="提交成功" description={`申请号：${code}`}>
      <ResultPageContent type={type} code={code} paymentType={paymentType} paid={paid} />
      <WhiteSpace />
      <Button block color="primary" fill="outline" onClick={() => push('/myProfile')}>
        <FormattedMessage id="common-back" />
      </Button>
    </ResultPage>
  )
}

export default ApplicationSubmitResult
